import React from 'react';
import { AdminTemplate, BinQuery } from '../../components';

export const BinQueryPage = () => {
    return (
        <AdminTemplate
            headerProps={{
                headerTitle: 'BIN Sorgulama Aracı',
                hideAddButton: true,
                hideDownloadButton: true,
                hideSearchBar: true,
            }}
        >
            <BinQuery />
        </AdminTemplate>
    );
};